/* ============================================================================
 * PROJECT FILTER CONSTANTS
 * Configuration constants for the ProjectFilterDropdown component
 * ============================================================================ */

// Default expanded sections
export const DEFAULT_EXPANDED_SECTIONS = ['pinned', 'favorites', 'recent', 'all'];

// Max recent projects to display
export const MAX_RECENT_PROJECTS = 5;

// Default dropdown max height
export const DEFAULT_MAX_HEIGHT = 400;
